import { css } from '@emotion/react';

export const filtersBlockStyles = {
    root: css({
        display: 'flex',
        padding: '8px 16px',
        gap: '12px',
    }),
    icon: css({
        cursor: 'pointer',
        height: '40px',
    }),
    filters: css({
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
        width: '100%',
        maxWidth: '100%',
        overflow: 'auto',
    }),
};
